import { render, staticRenderFns } from "./communicationQuestionModal.vue?vue&type=template&id=b169f0fe"
import script from "./communicationQuestionModal.vue?vue&type=script&lang=js"
export * from "./communicationQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports